export var PaymentMethodNameEnum;
(function (PaymentMethodNameEnum) {
    PaymentMethodNameEnum["AndroidPay"] = "android-pay";
    PaymentMethodNameEnum["ApplePay"] = "apple-pay";
})(PaymentMethodNameEnum || (PaymentMethodNameEnum = {}));
//# sourceMappingURL=payment-method-name.enum.js.map